export default __webpack_public_path__ + "static/media/Background_00285.ebbef0b2.png";